import { Link, useLocation } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  const location = useLocation();

  useDocumentMeta(
    "页面不存在 404 - 免费播放片大片",
    "抱歉，你访问的页面不存在或已被移除。返回免费播放片大片首页，继续浏览电影与电视剧资源。",
    "404,页面不存在,免费播放片大片",
  );

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 py-20 text-center">
      <p className="font-heading text-7xl font-black text-background-700 md:text-9xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-50 md:text-3xl">
        抱歉，你访问的页面不存在
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-400">
        页面可能已被移除、重命名，或链接地址输入有误。
      </p>
      <p className="mt-2 font-mono text-xs text-foreground-500">{location.pathname}</p>

      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-950 whitespace-nowrap transition-colors hover:bg-accent-400"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/movie"
          className="inline-flex items-center gap-2 rounded-md border border-background-600 px-5 py-2.5 text-sm font-medium text-foreground-100 whitespace-nowrap transition-colors hover:border-accent-400 hover:text-accent-400"
        >
          <i className="ri-film-line"></i>
          浏览电影
        </Link>
        <Link
          to="/tv"
          className="inline-flex items-center gap-2 rounded-md border border-background-600 px-5 py-2.5 text-sm font-medium text-foreground-100 whitespace-nowrap transition-colors hover:border-accent-400 hover:text-accent-400"
        >
          <i className="ri-tv-2-line"></i>
          浏览电视剧
        </Link>
      </div>
    </div>
  );
}